export enum ConsumerPhoneValidationSection {
  PHONE_NUMBER_VALIDATION_SECTION,
  EDIT_PHONE_NUMBER_SECTION
}
